/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {TransferResponseList} from '../../core/_models'
import {IconIsActive} from '../../../../../components/IconIsActive'

type Props = {
  transfer: TransferResponseList
}

const NameCell: FC<Props> = ({transfer}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span className='text-gray-800 text-hover-danger mb-1'>
          {transfer?.clientActiveAlert && <IconIsActive text={transfer?.clientAlertObservation} />}
          {transfer.clientName}
        </span>
      </div>
    </div>
  )
}

export {NameCell}
